<template>
    <v-container>

        <v-row>
            <!-- COMPANY NAME -->
            <v-col cols="12" class="company-name">
                {{ companyName }}
            </v-col>
        </v-row>
        <v-row>
            <!-- LEFT SIDE -->
            <v-col cols="12" md="8">
                <v-row>
                    <!-- IMG -->
                    <v-col cols="12" md="4">
                        <div class="company-img" :style="`background-image: url(${companyImg})`"/>
                    </v-col>
                    <!-- DETAILS -->
                    <v-col cols="12" md="8">
                        <user-details-card :details="companyDetails"/>
                    </v-col>
                </v-row>
            </v-col>
            <!-- RIGHT SIDE -->
            <v-col cols="12" md="4">
                <current-subscription-card :price-id="priceId"/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import UserDetailsCard from "@/components/common/cards/UserDetailsCard";
import CurrentSubscriptionCard from "@/components/common/cards/CurrentSubscriptionCard";
export default {
    name: "Profile",
    components: {CurrentSubscriptionCard, UserDetailsCard},
    data(vm) {
        return {
            typesOptions: [
                {name: vm.$t('company.types.club'), value: 'club'},
                {name: vm.$t('company.types.gym'), value: 'gym'},
                {name: vm.$t('company.types.institution'), value: 'institution'}
            ],
        }
    },
    computed: {
        companyName(vm = this) {
            return vm.account?.name || vm.$t('common.not_available_short')
        },
        companyImg(vm = this) {
            if (!vm.account.avatar) return vm.imgPlaceholder
            return vm.account.avatar
        },
        type(vm = this) {
            if(!vm.account?.type) return vm.$t('common.not_available_short')
            return vm.typesOptions.find(type => type.value === vm.account.type)?.name || ''
        },
        phone(vm = this) {
            if(!vm.account?.phone) return vm.$t('common.not_available_short')
            return `${vm.account.country.phoneCode} ${vm.account.phone}`
        },
        companyDetails(vm = this) {
            if (!vm.account) return null
            return [
                {name: vm.$t('company.address'), value: vm.account.address},
                {name: vm.$t('common.email'), value: vm.account.email},
                {name: vm.$t('company.type'), value: vm.type},
                {name: vm.$t('entrance.experience'), value: vm.account.experience},
                {name: vm.$t('common.phone'), value: vm.phone},
            ]
        },
        priceId(vm = this) {
            return vm.account?.stripeAccount?.currentSubscription?.priceId || null
        }
    }
}
</script>

<style scoped>

.company-name {
    font-weight: 600;
    font-size: 32px;
    line-height: 40px;
    text-align: center;
    color: #03342C;
}

.company-img {
    border-radius: 38px;
    height: 100%;
    min-height: 150px;
    background-color: rgba(51, 51, 51, .1);
    background-position: center;
    background-size: cover;
}

</style>